export default __webpack_public_path__ + "static/media/Credit-Rating-17.08.2026.7e4a39d9.pdf";